import React from 'react';

import svg from './assets/icons-16-local-shipping-local.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

/** @deprecated Use the Icon component from the design-system-core-components package. */
export const IconLocalShippingLocal = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-local-shipping-local" />
);
